import { WhatsappTemplateModel } from '../data';

export interface WhatsAppTemplatesPayloadModel {
  templates: WhatsappTemplateModel[];
}
